// extracted by mini-css-extract-plugin
export default {"App":"WarningAdminModal_App__VmLHz","wrapper":"WarningAdminModal_wrapper__Oj1oq"};